import request from '../utils/request'

/**
 * 退货相关接口
 */

// 申请退货
export function applyRefund(data) {
  return request({
    url: '/h5/refund/apply',
    method: 'post',
    data
  })
}

// 退货详情
export function getRefundDetail(id) {
  return request({
    url: `/h5/refund/detail/${id}`,
    method: 'get'
  })
}

// 根据订单ID获取退货信息
export function getRefundByOrderId(orderId) {
  return request({
    url: `/h5/refund/byOrder/${orderId}`,
    method: 'get'
  })
}

// 我的退货列表
export function getRefundList(params) {
  return request({
    url: `/h5/refund/list/${params.page}/${params.row}`,
    method: 'get',
    params
  })
}

// 填写退货物流
export function fillRefundExpress(data) {
  return request({
    url: '/h5/refund/fillExpress',
    method: 'post',
    data
  })
}

// 取消退货申请
export function cancelRefund(id) {
  return request({
    url: `/h5/refund/cancel/${id}`,
    method: 'post'
  })
}
